__turbopack_context__.v({
  "search-bar": "search-bar-component-module-scss-module__AKq-Ka__search-bar",
  "search-bar--focused": "search-bar-component-module-scss-module__AKq-Ka__search-bar--focused",
  "search-bar__icon": "search-bar-component-module-scss-module__AKq-Ka__search-bar__icon",
  "search-bar__input": "search-bar-component-module-scss-module__AKq-Ka__search-bar__input",
  "search-bar__return-icon": "search-bar-component-module-scss-module__AKq-Ka__search-bar__return-icon",
  "search-bar__wrapper": "search-bar-component-module-scss-module__AKq-Ka__search-bar__wrapper",
  "search-bar_return-button": "search-bar-component-module-scss-module__AKq-Ka__search-bar_return-button",
});
